import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {base64Encode, RequestError, Store} from '@softline/core';
import {Observable, Subscription} from 'rxjs';
import {Product} from '../../data/product';
import {
  BackNavigable,
  BackNavigationService,
  ScannerStore,
  showRequestErrors,
  SOFTLINE_API_FILE,
  SOFTLINE_FEATURE_SCANNER,
  SOFTLINE_FEATURE_TITLE,
  TitleStore } from '@softline/application';
import {map, skip} from 'rxjs/operators';
import {Router} from '@angular/router';
import {SOFTLINE_FEATURE_PRODUCT_SCAN} from '../../product-scan.shared';
import {ProductStore} from '../../store/product.store';
import {MessageBarStore, SOFTLINE_FEATURE_MESSAGE_BAR} from '@softline/ui-core';
import {CommonModule} from '@angular/common';
import {ProductDetailFieldComponent} from './product-detail-field/product-detail-field.component';

import { SecureImagePipe } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'lib-product-detail',
    imports: [CommonModule, ProductDetailFieldComponent,
    SecureImagePipe,
    TranslatePipe],
    templateUrl: './product-detail.component.html',
    styleUrls: ['./product-detail.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDetailComponent implements OnInit, OnDestroy, BackNavigable{

  readonly product$: Observable<Product | null> = this.store.observe(SOFTLINE_FEATURE_PRODUCT_SCAN, ProductStore.getters.data);
  private subscription?: Subscription;

  readonly filePaths$ = this.product$.pipe(
    map(o => o?.media.map(p => SOFTLINE_API_FILE.replace('{{key}}', '') + base64Encode(JSON.stringify(p)))),
  );

  constructor(private store: Store,
              protected router: Router,
              private backNavigationService: BackNavigationService) { }

  ngOnInit(): void {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '#PRODUCT_SCAN.DETAIL.TITLE');
    this.backNavigationService.set(this);

    this.subscription = this.store.observe(SOFTLINE_FEATURE_SCANNER, ScannerStore.getters.latest)
        .pipe(skip(1))
        .subscribe(async o => {
          try {
            await this.store.dispatch(SOFTLINE_FEATURE_PRODUCT_SCAN, ProductStore.actions.loadScan, {scan: o});
          } catch (e: any) {
            if (e instanceof RequestError) {
              await this.store.dispatch(SOFTLINE_FEATURE_MESSAGE_BAR, MessageBarStore.actions.error, {
                title: '#PRODUCT_SCAN.MESSAGES.ERROR.TITLE',
                message: '#PRODUCT_SCAN.MESSAGES.ERROR.LOAD'
              });
            } else {
              showRequestErrors(this.store, e);
            }
          }
        });
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed)
      this.subscription.unsubscribe();
    this.subscription = undefined;

    this.backNavigationService.set(undefined);
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '');
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/artikelinfo']);
  }
}
